import { ButtonERP, PrimeReactModal } from "@finanedi.es/storybook"
import { putFacturaMarcarTransaccionAutomatica } from "api/Factura.service"
import { STATUSCORRECT } from "common/components/ModalVerDocumento/constants"
import notification from "common/utils/notification"
import { MODAL_STYLES } from "constants/primereactStyles"
import { Form, FormikProps, withFormik } from "formik"
import { TFunction } from "i18next"
import { InputTextarea } from "primereact/inputtextarea"
import * as Yup from "yup"

interface FormValues {
  motivo: string
}

interface ModalPagoCobroManualModalOnlyProps {
  show: boolean
  isVenta: boolean
  onHide: () => void
  document: {
    serie: string | null | undefined
    id: string | undefined
  }
  t: TFunction
}

interface PagoCobroManualFormProps extends ModalPagoCobroManualModalOnlyProps {
  updateData?: () => void
}

const ModalPagoCobroManualForm = ({
  show = true,
  onHide,
  document,
  isVenta,
  values,
  handleChange,
  resetForm,
  t,
  isValid,
  isSubmitting,
}: ModalPagoCobroManualModalOnlyProps & FormikProps<FormValues>) => (
  <PrimeReactModal
    visible={show}
    className='tw-w-128 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
    baseZIndex={20}
    ptContext={MODAL_STYLES}
    closable={false}
    keepInViewport={false}
    header={`${t("modalPagoCobroManual.invoiceTitle")} ${
      document?.serie ?? ""
    }`}
  >
    <Form className='gap-4 tw-flex tw-flex-col'>
      <div className='tw-flex tw-flex-col'>
        <label
          htmlFor='motivo'
          className='tw-font-medium'
        >
          {isVenta
            ? t("modalPagoCobroManual.noteColled")
            : t("modalPagoCobroManual.notePaid")}
        </label>
        <InputTextarea
          id='motivo'
          name='motivo'
          placeholder={`${
            isVenta
              ? t("modalPagoCobroManual.placeholderColled")
              : t("modalPagoCobroManual.placeholderPaid")
          }`}
          value={values.motivo ?? undefined}
          onChange={handleChange}
          autoResize={false}
          maxLength={250}
          className='tw-h-32 tw-max-h-32 tw-overflow-y-auto tw-resize-none'
        />
      </div>

      <div className='gap-2 mt-4 tw-flex tw-justify-end tw-gap-3'>
        <ButtonERP
          customize={{
            size: "md",
            type: "transparent",
          }}
          onClick={() => {
            onHide()
            resetForm()
          }}
          label={`${t("modalPagoCobroManual.cancel")}`}
        />

        <ButtonERP
          type='submit'
          customize={{
            size: "md",
            type: "primary",
          }}
          loading={isSubmitting}
          disabled={!isValid || !values.motivo?.length}
          label={`${
            isVenta
              ? t("modalPagoCobroManual.saveColled")
              : t("modalPagoCobroManual.savePaid")
          }`}
        />
      </div>
    </Form>
  </PrimeReactModal>
)

const PagoCobroManualForm = withFormik<PagoCobroManualFormProps, FormValues>({
  validateOnChange: true,
  validateOnBlur: true,
  mapPropsToValues: () => ({
    motivo: "",
  }),
  validationSchema: ({ t }: PagoCobroManualFormProps) =>
    Yup.object().shape({
      motivo: Yup.string().required(`${t("modalPagoCoborManual.error.note")}`),
    }),
  handleSubmit: async (values, { props, resetForm }) => {
    if (props.document.id) {
      const resp = await putFacturaMarcarTransaccionAutomatica(
        props.document.id,
        {
          motivo: values.motivo,
          id: props.document.id,
        }
      )
      if (resp.status === STATUSCORRECT) {
        notification.success({
          body: `${props.t(
            props.isVenta
              ? "modalPagoCobroManual.msg.collectCorrect"
              : "modalPagoCobroManual.msg.collectCorrect"
          )}`,
        })
        props.updateData?.()
        props.onHide()
        resetForm()
      }
    }
  },
})(ModalPagoCobroManualForm)

export default PagoCobroManualForm
